import type { AdminOrganization } from "../../utils/types";

type OrgSelectorProps = {
  organizations: AdminOrganization[];
  selectedOrgId: number | null;
  onChange: (orgId: number | null) => void;
};

export const OrgSelector = ({
  organizations,
  selectedOrgId,
  onChange,
}: OrgSelectorProps) => (
  <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
    <label className="mb-2 block text-sm font-medium text-slate-700">
      Select Organization
    </label>
    <select
      value={selectedOrgId ?? ""}
      onChange={(e) => {
        const orgId = e.target.value ? parseInt(e.target.value, 10) : null;
        onChange(orgId);
      }}
      className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:border-[#4B7F73] focus:outline-none focus:ring-1 focus:ring-[#4B7F73]"
    >
      <option value="">-- Select Organization --</option>
      {organizations.map((org) => (
        <option key={org.id} value={org.id}>
          {org.name}
        </option>
      ))}
    </select>
  </div>
);
